module.exports = __webpack_public_path__ + "../resources/img/@map.5b4dfadf.jpg";